// -----------------------------------------------
// スライダー初期化
// -----------------------------------------------
function initSwiper() {
  // スライダー
  if (document.querySelector('.js-pickup-slider')) {
    const swiper = new Swiper('.js-pickup-slider', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 36,
      speed: 800,
      pagination: {
        el: '.pickup-slider__pagination',
        clickable: true,
      },
      navigation: {
        prevEl: '.pickup-slider__prev',
        nextEl: '.pickup-slider__next',
      },
      // 自動再生
      autoplay: {
        // 流れるように動かす
        delay: 3000,
      },
      breakpoints: {
        // 960px以上の場合
        960: {
          slidesPerView: 'auto',
          spaceBetween: 50,
        },
      },
    });
  }
}

// -----------------------------------------------
// 著者カードの続きを読むボタン設定
// -----------------------------------------------
function setupReadMoreButtons() {
  const moreButtons = document.querySelectorAll('.js-card-more');
  if (moreButtons.length === 0) return; // ボタンがない場合は終了

  moreButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      // ボタンの親要素を取得し、その中のテキスト要素を見つける
      const cardText = button.closest('.single__card').querySelector('.single__card-text');

      if (cardText) {
        // テキスト要素から隠しクラスを削除
        cardText.classList.remove('single__card-text--hidden');
      }

      button.style.display = 'none';
    });
  });
}

// -----------------------------------------------
// サイドバーMOREボタンクリック
// -----------------------------------------------
function addSidebarMoreButton(element, height, className) {
  if (element.offsetHeight > height) {
    element.classList.add(className);
  }
}

function setupSidebarMoreButtons() {

  // サイドバーMOREボタン追加
  if (document.querySelector('.js-sidebar-more-target')) {

    // category-listの高さをチェック
    const categoryList = document.querySelectorAll('.js-sidebar-more-target.category-list');
    categoryList.forEach((element) => {
      addSidebarMoreButton(element, 363, 'more');
    });

    // tag-listの高さをチェック
    // const tagList = document.querySelectorAll('.js-sidebar-more-target.tag-list');
    // addSidebarMoreButton(tagList, 132, 'more');
  }

  // サイドバーMOREボタンクリック
  if (document.querySelector('.js-sidebar-more-button')) {
    // すべてのjs-more-buttonを取得
    const moreButtons = document.querySelectorAll('.js-sidebar-more-button');

    moreButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // 対応するjs-sidebar-more-targetを取得
        const moreTarget = this.previousElementSibling;

        if (moreTarget && moreTarget.classList.contains('js-sidebar-more-target')) {
          // 高さを取得し、設定する
          const targetHeight = moreTarget.scrollHeight;
          moreTarget.style.height = `${targetHeight}px`;
          this.style.display = 'none';
        }
      });
    });
  }
}


//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  setupReadMoreButtons();
  initSwiper();
  setupSidebarMoreButtons();
});

//-------------------------------------------
// Windowロードイベント
//-------------------------------------------
window.addEventListener('load', () => {
});
